<template>
  <div>
    <div class="doses-list">
      <h4>{{ title }}:</h4>
      <div v-for="(item, index) in doses" :key="index">
        <div
          class="doses-list-item"
          :class="item.cor"
          @click="openModalVacina(item)"
        >
          <strong>{{ item.dose }}</strong>
          <span>{{ item.dt_plc_br }}</span>
        </div>
      </div>
    </div>

    <modal-inserir-vacina
      :show.sync="modalVacinas.show"
      :title="`${title} - ${modalVacinas.item?.dose}`"
      :item="modalVacinas.item"
      :cidadao="cidadao"
      @saved="onDoseSaved"
      @closed="onModalClosed"
    />
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import ModalInserirVacina from './ModalInserirVacina.vue'

export default {
  name: 'ItemDoses',
  props: {
    title: { type: String, default: '' },
    doses: { type: [Array, Boolean], default: false },
    cidadao: { type: Object, default: () => null },
  },
  components: { ModalInserirVacina },
  mixins: [utils],
  data() {
    return {
      modalVacinas: {
        show: false,
        item: null,
      },
    }
  },
  methods: {
    openModalVacina(item) {
      if (item.cor === 'white' || item.cor === 'red') {
        this.modalVacinas.item = item
        this.modalVacinas.show = true
      }
    },

    onDoseSaved(payload) {
      this.$emit('disabled-btn-processar', false)
      this.$emit('show-alert-processar', false)
      this.modalVacinas.show = false
    },

    onModalClosed() {
      this.modalVacinas.item = null
      this.modalVacinas.show = false
    },
  },
}
</script>

<style scoped lang="scss">
.doses-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  gap: 20px;
  margin: 20px 0;
  background-color: #f1f0f5;
  padding: 15px;
  h4 {
    font-size: 16px;
    margin-bottom: 0;
    width: 15%;
  }
  .doses-list-item {
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #000;
    border-radius: 6px;
    &.red {
      background: #ffb3b3 !important;
      cursor: pointer;
      // border-color: #990000 !important;
    }
    &.green {
      background: #b3ffb3;
      // border-color: #008000 !important;
    }
    &.white {
      background: #fff;
      cursor: pointer;
      // border-color: #000 !important;
    }
  }
}
</style>
